import { Form, Input, Modal } from "antd";
import React, { useEffect, useState } from "react";
import ProjectStore from "../../../../stores/Admin/ProjectStore";
import { observer } from "mobx-react-lite";

const { TextArea } = Input;

export interface ProjectEditDialogProps {
  visible: boolean;
  projectInfo: {
    id: number;
    name: string;
    des?: string;
    sort?: number;
  };
  close: () => void;
}

const ProjectEditDialog: React.FC<ProjectEditDialogProps> = (props) => {
  const [form] = Form.useForm();

  useEffect(() => {
    form.resetFields();
    form.setFieldsValue(props.projectInfo);
  }, [props.visible]);

  const submit = () => {
    const { name, des, sort } = form.getFieldsValue();
    if (!name?.trim()) return;
    ProjectStore.editProject(props.projectInfo.id, name, des, sort === undefined ? undefined : +sort);
    props.close();
  };

  return (
    <Modal
      title="编辑项目"
      visible={props.visible}
      onCancel={props.close}
      onOk={submit}
      okText="确认"
      cancelText="取消"
    >
      <Form form={form}>
        <Form.Item label="项目名称" name="name" rules={[{ required: true, message: "名称不能为空" }]}>
          <Input placeholder="请输入项目名称" />
        </Form.Item>
        <Form.Item label="项目描述" name="des">
          <TextArea rows={4} placeholder="输入项目描述" maxLength={200} showCount />
        </Form.Item>
        <Form.Item label="排序权重（升序）" name="sort">
          <Input type="number" />
        </Form.Item>
      </Form>
    </Modal>
  );
};

export default observer(ProjectEditDialog);
